'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STYLES = exports.STATE = exports.SIZES = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getClassNames = getClassNames;
exports.getProps = getProps;
exports.default = decorate;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SIZES = exports.SIZES = {
  LARGE: 'lg',
  MEDIUM: 'md',
  SMALL: 'sm',
  XSMALL: 'xs'
};

var STATE = exports.STATE = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};

var STYLES = exports.STYLES = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

function getClassNames(props, prefixClass) {
  var _ref;

  var size = props.size,
      shape = props.shape,
      className = props.prefixClass;

  var pre = prefixClass || className;

  pre = pre ? pre + '-' : '';

  return _ref = {}, _defineProperty(_ref, '' + className, !!className), _defineProperty(_ref, '' + pre + size, !!size), _defineProperty(_ref, '' + pre + shape, !!shape), _ref;
}

function getProps(props) {
  var elementProps = {};
  Object.entries(props).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        propName = _ref3[0],
        propValue = _ref3[1];

    elementProps[propName] = propValue;
  });
  return elementProps;
}

function decorate() {
  var skin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    size: null,
    shape: null
  };

  return function (Component) {
    var size = skin.size,
        shape = skin.shape;

    var propTypes = Component.propTypes || (Component.propTypes = {});
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});

    if (size === true) {
      propTypes.size = _propTypes2.default.oneOf((0, _values2.default)(SIZES));
      defaultProps.size = null;
    } else if ((typeof size === 'undefined' ? 'undefined' : _typeof(size)) === 'object') {
      propTypes.size = _propTypes2.default.oneOf(size.oneOf);
      defaultProps.size = size.default;
    }

    if (shape === true) {
      propTypes.shape = _propTypes2.default.oneOf([].concat(_toConsumableArray((0, _values2.default)(STATE)), _toConsumableArray((0, _values2.default)(STYLES))));
      defaultProps.shape = STYLES.DEFAULT;
    } else if ((typeof shape === 'undefined' ? 'undefined' : _typeof(shape)) === 'object') {
      propTypes.shape = _propTypes2.default.oneOf(shape.oneOf);
      defaultProps.shape = shape.default;
    }

    return Component;
  };
}